import { Card, CardMedia, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router";


export interface CategoryCardProps {
    src: string | undefined,
    alt: string,
    cardTitle: string,
};


const CategoryCard: React.FC<CategoryCardProps> = ({src, alt, cardTitle}) => {
    const navigate = useNavigate();



    const handleCardClick = () => {
navigate('/browse')
    }

    return (
        <Grid item xs={12} sm={6} md={6}>
            <Card sx={{position: "relative", height: "80%"}}>
                <CardMedia component="img" src={src} alt={alt} onClick={handleCardClick} />
                <Typography
                    variant="h3"
                    sx={{
                        position: "absolute",
                        color: "white",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}
                    onClick={handleCardClick}
                >
                  {cardTitle}
                </Typography>
            </Card>
          </Grid>
    );
}

export default CategoryCard;